var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdyen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#32AA52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186 93.2671C186 80.417 175.583 70 162.733 70H71.6619V98.9992H131.019C134.69 99.0008 137.667 101.976 137.667 105.647V157.001H124.981C121.31 157.001 118.333 154.024 118.333 150.353V113.5H93.2668C80.4169 113.5 70 123.917 70 136.767V162.733C70 175.583 80.4169 186 93.2668 186H186V93.2671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdyen);
export default __webpack_public_path__ + "static/media/icon-adyen.f3901cc7ea5a10ee1e4966c6d7544e96.svg";
export { ForwardRef as ReactComponent };